export const MoveFixture = {
  IsMovingHouse: false,
  AccountStart: "30/06/2019",
  MoveInDate: "30/06/2019",
  MoveOutDate: null,
  MoveFromAddress: null,
  Situation: "Other",
  SituationOtherDetails: "Testing ELEC, LPG and BB",
};
